export default "__VITE_ASSET__J6L2WE$v__"